import { isDecoratorArgs, isPropertyDecoratorArgs } from 'decorator-setup';

import { concat } from 'rise-ui/utils/array.js';
import { get } from 'rise-ui/utils/object.js';
import { computedDecorator } from 'rise-ui/utils/object/computed.js';

/**
 * @decorator
 */
export const collect = computedDecorator(
  '@collect',
  values => concat(...values),
  [ '...arrayPaths' ],
);

/**
 * @decorator
 */
export const truth = computedDecorator(
  '@truth',
  values => concat(...values)
    .reduce((o, id) => (o[id] = true) && o, {}),
  [ '...arrayPaths' ],
);

/**
 * @decorator
 */
export function mapBy(...args) {
  const isNotFactory = isDecoratorArgs(...args);
  if (isNotFactory || args.length !== 2) {
    throw new Error(`@mapBy expects arguments: arrayPath, mappedPath`);
  }
  return function(target, propertyKey, descriptor) {
    if (!isPropertyDecoratorArgs(...arguments)) {
      throw new Error(`@mapBy should be applied to a property`);
    }
    const [ arrayPath, mappedPath ] = args;
    return {
      get() {
        return get(this, arrayPath)?.map(o => get(o, mappedPath)) || [];
      },
      set() {
        throw new Error(`@mapBy property cannot be set`);
      },
    };
  }
}
